var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckmarkCircleGrayFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016ZM7.16658 8.95972L10.1464 5.97994C10.3416 5.78468 10.6582 5.78468 10.8535 5.97994C11.031 6.15745 11.0471 6.43523 10.9019 6.63097L10.8535 6.68705L7.52014 10.0204C7.34263 10.1979 7.06485 10.214 6.86911 10.0688L6.81303 10.0204L5.14637 8.35371C4.9511 8.15845 4.9511 7.84187 5.14637 7.64661C5.32388 7.4691 5.60165 7.45296 5.79739 7.5982L5.85347 7.64661L7.16658 8.95972Z",
    fill: "#CFD6D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkCircleGrayFill);
export default __webpack_public_path__ + "static/media/icon-checkmark-circle-gray-fill.c0ee89be0cbc5853c29d956a7cf422a6.svg";
export { ForwardRef as ReactComponent };